import Swiper from "swiper/bundle";

class Blocks {
  constructor () {
    this.mainvisual();
    this.bodyAbout();
  }

  mainvisual () {
    new Swiper('.about-mainvisual [data-plugin="slider"]',{
      loop: true,
      effect: 'fade',
      speed: 1200,
      fadeEffect: {
        crossFade: true, // クロスフェードを有効にする（フェードモードの場合 true 推奨）
      },
      autoplay:{
        delay: 7000,
        disableOnInteraction: false,
        waitForTransition: false
      },
      navigation: {
        nextEl: '.about_next',
        prevEl: '.about_prev'
      },
      pagination: {
        el: ".about_pager",
        type: 'bullets',
        clickable: true,
      },
    });
  }

  bodyAbout () {
    $('body').addClass('is--about');
  }
}

const init = () => {
  new Blocks;
};

export default function ABOUT () {
  $(init)
}